import React from 'react';
import { DoneRounded } from '@mui/icons-material';
import { useLocation } from 'react-router-dom';
import ContentError from '../Components/Error/ContentError';

const ResponseRegistered = function ResponseRegistered() {
  const { responseText } = useLocation()?.state || {};

  return (
    responseText && (
      <div
        style={{
          width: '100%',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ContentError
          icon={<DoneRounded sx={{ color: '#acacac', fontSize: '2rem' }} />}
          text={responseText}
          sizes={{
            title: '1.5rem',
          }}
        />
      </div>
    )
  );
};

export default ResponseRegistered;
